/**
 * @file:  提示类 划过泡泡 | 点击 泡泡
 * 二次封装 Popover
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/02      1.0     First version
 *
 * @param needIcon 感叹号图标,默认有，可配置否，
 * @param iconClassName 配置图标样式
 * @param content 显示内容
 * @param children 子内容
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import {Popover} from "antd";
const IconTips = ({needIcon=true,placement="topRight",content="",iconClassName="",trigger="hover",className="",children}) => {
    return (<Popover placement={placement}
                     className={className}
                     trigger={trigger}
                     content={content} >
        {children}
        {needIcon&&<span className={`iconfont icon-icon-line-tip${iconClassName?" "+iconClassName:""}`}></span>}
    </Popover>);
}

export default IconTips;
